import React from 'react';
import ReactDOM from 'react-dom';
import OTZWizardApp from './react-component/OtzWizardApp';

ReactDOM.render(
    <React.StrictMode>
        <OTZWizardApp />
    </React.StrictMode>,
    document.getElementById('app'),
);
